import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Section from "../../UI/Section";
import HoverWidget from "../../UI/HoverWidget";
import getMyProfileCompletePercent from "../../../_selectors/userSelectors/getMyProfileCompletePercent";
import Alert from "../../UI/Alert";
import Wrapper from "../../../_hoc/Wrapper";
import getIsAgeSet from "../../../_selectors/userSelectors/getIsAgeSet";

const Info = ({ profileComplete, isAgeSet }) => {
  return (
    <Section white>
      {isAgeSet ? null : (
        <Alert
          danger
          message={
            <Wrapper>
              {" "}
              <Link to="/profile">
                <strong>Update your profile</strong>{" "}
              </Link>
              so that you can feature in search results.
            </Wrapper>
          }
        />
      )}

      
      <div className="dev-table">
        <HoverWidget
          title="Profile Complete"
          stat={`${profileComplete}%`}
          progress
          width={profileComplete}
          text="Updating the profile will make sure that you feature in the search results"
          link="/profile"
          linkText="Update Profile"
          progressInfo={profileComplete >= 60}
          progressDanger={profileComplete < 30}
          progressWarning={profileComplete >= 30 && profileComplete < 60}
          danger={profileComplete < 30}
          warning={profileComplete >= 30 && profileComplete < 60}
        />
      </div>
    </Section>
  );
};
const mapStateToProps = (state, ownProps) => ({
  profileComplete: getMyProfileCompletePercent(state),
  isAgeSet: getIsAgeSet(state)
});

export default connect(mapStateToProps)(Info);



// WEBPACK FOOTER //
// ./src/_components/Home/Info/index.js